import { MOCK_API_URL, SEEK_ENV } from 'src/config';
import { useMutation } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import { CreateProfileAvatarDocument } from 'src/types/graphql';

export const useCreateProfileAvatarMutation = () => {
  const { language, locale } = useAppConfig();
  const languageLocale = `${language}-${locale}`;

  const [createProfileAvatarInput, response] = useMutation(
    CreateProfileAvatarDocument,
    {
      variables: {
        locale: languageLocale,
      },
    },
  );

  return {
    createProfileAvatarInput,
    createProfileAvatarResponse: response.data?.createProfileAvatar,
    createProfileAvatarError: Boolean(
      response.error ||
      response.data?.createProfileAvatar?.__typename ===
        'CreateProfileAvatarFailure',
    ),
  };
};

export const uploadProfileAvatar = async (
  file: File,
  url: string,
): Promise<void> => {
  try {
    // In local/test environments, use the mock server instead of the S3 URL
    const uploadUrl =
      (SEEK_ENV === 'local' || SEEK_ENV === 'test') && MOCK_API_URL
        ? `${MOCK_API_URL}/avatar`
        : url;

    const response = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
    });

    if (!response.ok) {
      throw new Error(
        `Upload failed with status ${response.status}: ${response.statusText}`,
      );
    }
  } catch (error) {
    if (error instanceof Error) {
      error.name = `Profile avatar upload error: ${error.name}`;
      throw error;
    }
    throw error;
  }
};
